import constants from '@/constants'

export function canCancelUploadMessage(message, currentUserId) {
  if (!message) {
    return false
  }
  if (!currentUserId) {
    return false
  }

  const senderUserId = parseInt(message.senderDisplayName, 10)
  const normalizedCurrentUserId = parseInt(currentUserId, 10)
  if (senderUserId !== normalizedCurrentUserId) {
    return false
  }

  const metadata = message.metadata || {}
  const isUploading = metadata.uploading === 'true'
  const isSending = metadata.state === constants.CHAT.STATES.SENDING

  return isUploading && isSending
}
